export enum AuthType {
  FIREBASE,
  STCP
}
